import { APP_INITIALIZER, inject, makeEnvironmentProviders } from '@angular/core';
import type { EnvironmentProviders } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostHogService } from '../services/posthog.service';

function initAnalytics() {
  const posthogService = inject(PostHogService);

  return () => {
    posthogService.init(environment.posthogKey, {
      api_host: environment.posthogHost,
      capture_pageview: false,
      capture_exceptions: true,
    });
  };
}

export function provideAnalytics(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: initAnalytics,
      multi: true,
    },
  ]);
}
